module.exports = __webpack_public_path__ + "img/art-qr.1f1d9e11.png";